import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import CrashLogo from 'modules/core/components/CrashLogo'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import useSubscribe from 'modules/core/hooks/useSubscribe'
import i18n from 'modules/core/lib/i18n'
import { EventTypes } from 'modules/core/lib/pubSub'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'
import jobs from 'modules/ats/store/collections/jobs'
import type AtsCompany from 'modules/ats/store/models/AtsCompany'
import type Job from 'modules/ats/store/models/Job'

const JobDetails = () => {
  const params = useParams()
  const { navigation } = useNavigation()
  const jobId = Number(params.jobId)

  useSubscribe([EventTypes.JOB_POSTING_STATUS_CHANGED], () => {
    atsCompanies.fetch()
  })

  // TODO: migrate to GraphQL
  const job = jobs.find({ id: jobId })

  if (!job) {
    return (
      <CrashLogo
        crashButtonLabel={i18n.t('ats.job_details.crash_deleted_job_message.button')}
        crashButtonRoute={navigation.ats.jobs.fullPath()}
        crashDescription={i18n.t('ats.job_details.crash_deleted_job_message.description')}
        compact
      />
    )
  }

  const atsCompany = atsCompanies.current

  if (!atsCompany) {
    return <CrashLogo compact />
  }

  return <Outlet context={{ job, atsCompany }} />
}

export const useJobDetailsContext = () => useOutletContext<{ job: Job; atsCompany: AtsCompany }>()

export default JobDetails
